module.exports = __webpack_public_path__ + "static/img/chromeNotification.514079a7.png";